export default "__VITE_ASSET__C$Z_C7r$__"